"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openTelemetryIntegration = void 0;
var open_telemetry_1 = require("./open-telemetry");
Object.defineProperty(exports, "openTelemetryIntegration", { enumerable: true, get: function () { return open_telemetry_1.openTelemetryIntegration; } });
//# sourceMappingURL=index.js.map